// import React from 'react';
// import { Smartphone, Tablet, Monitor } from 'lucide-react';

// interface CustomizationState {
//   marketCardLayout: number;
//   marketCardColors: {
//     background: string;
//     text: string;
//     button: string;
//     buttonText: string;
//     status: string;
//     border: string;
//   };
//   footerNavLayout: number;
//   footerNavColors: {
//     background: string;
//     text: string;
//     activeBackground: string;
//     activeText: string;
//     icon: string;
//   };
//   buttonConfig: {
//     count: number;
//     theme: string;
//     layout: string;
//     colors: {
//       primary: string;
//       secondary: string;
//       text: string;
//     };
//   };
//   devicePreview: 'mobile' | 'tablet' | 'desktop';
// }

// interface PreviewPanelProps {
//   customization: CustomizationState;
//   marketCardLayouts: any[];
//   footerNavLayouts: any[];
// }

// const PreviewPanel: React.FC<PreviewPanelProps> = ({ 
//   customization, 
//   marketCardLayouts, 
//   footerNavLayouts 
// }) => {
//   const getDeviceClass = () => {
//     switch (customization.devicePreview) {
//       case 'mobile':
//         return 'w-80 h-[600px]';
//       case 'tablet':
//         return 'w-96 h-[800px]';
//       case 'desktop':
//         return 'w-full h-[600px]';
//       default:
//         return 'w-80 h-[600px]';
//     }
//   };

//   const getDeviceIcon = () => {
//     switch (customization.devicePreview) {
//       case 'mobile':
//         return <Smartphone className="w-4 h-4" />;
//       case 'tablet':
//         return <Tablet className="w-4 h-4" />;
//       case 'desktop':
//         return <Monitor className="w-4 h-4" />;
//       default:
//         return <Smartphone className="w-4 h-4" />;
//     }
//   };

//   const MarketCardComponent = marketCardLayouts.find(
//     layout => layout.id === customization.marketCardLayout
//   )?.component;

//   const FooterNavComponent = footerNavLayouts.find(
//     layout => layout.id === customization.footerNavLayout
//   )?.component;

//   return (
//     <div className="bg-gray-50 rounded-lg p-4">
//       <div className="flex items-center justify-between mb-4">
//         <h3 className="text-lg font-semibold text-gray-900">Live Preview</h3>
//         <div className="flex items-center gap-2 text-sm text-gray-600">
//           {getDeviceIcon()}
//           <span className="capitalize">{customization.devicePreview}</span>
//         </div>
//       </div>

//       {/* Device Frame */}
//       <div className="flex justify-center">
//         <div className={`${getDeviceClass()} bg-white rounded-lg shadow-lg border border-gray-200 overflow-hidden`}>
//           {/* App Header */}
//           <div className="bg-blue-600 text-white p-4 flex items-center justify-between">
//             <div className="flex items-center gap-2">
//               <div className="w-6 h-6 bg-white bg-opacity-20 rounded"></div>
//               <span className="font-semibold">KALYAN MATKA</span>
//             </div>
//             <div className="w-6 h-6 bg-white bg-opacity-20 rounded"></div>
//           </div>

//           {/* App Content */}
//           <div className="p-4 space-y-4 flex-1 overflow-y-auto">
//             {/* Promotional Banner */}
//             <div className="bg-gradient-to-r from-blue-800 to-blue-900 text-white p-4 rounded-lg">
//               <div className="text-sm font-medium mb-1">FUNBB LAUNCHES COMPREHENSIVE GUIDE</div>
//               <div className="text-xs opacity-90">ON HOW TO PLAY ONLINE SATTA MATKA</div>
//             </div>

//             {/* Action Buttons */}
//             <div className="flex gap-2">
//               <button 
//                 className="flex-1 bg-blue-600 text-white py-2 px-4 rounded-lg text-sm font-medium flex items-center justify-center gap-2"
//                 style={{
//                   backgroundColor: customization.buttonConfig.colors.primary,
//                   color: customization.buttonConfig.colors.text
//                 }}
//               >
//                 <div className="w-4 h-4 bg-white bg-opacity-20 rounded"></div>
//                 STARLINE
//               </button>
//               <button 
//                 className="flex-1 bg-blue-500 text-white py-2 px-4 rounded-lg text-sm font-medium flex items-center justify-center gap-2"
//                 style={{
//                   backgroundColor: customization.buttonConfig.colors.secondary,
//                   color: customization.buttonConfig.colors.text
//                 }}
//               >
//                 <div className="w-4 h-4 bg-white bg-opacity-20 rounded"></div>
//                 JACKPOT
//               </button>
//             </div>

//             {/* Contact Info */}
//             <div className="space-y-2">
//               <div className="flex items-center gap-2 text-sm text-gray-600">
//                 <div className="w-4 h-4 bg-gray-400 rounded"></div>
//                 <span>+91 1234 5678 90</span>
//               </div>
//               <div className="flex items-center gap-2 text-sm text-gray-600">
//                 <div className="w-4 h-4 bg-gray-400 rounded"></div>
//                 <span>+44 1234 5678 90</span>
//               </div>
//             </div>

//             {/* Market Cards Preview */}
//             <div className="space-y-3">
//               <h4 className="text-sm font-medium text-gray-700">Market Cards</h4>
//               {MarketCardComponent && (
//                 <div className="space-y-2">
//                   <MarketCardComponent colors={customization.marketCardColors} />
//                   <MarketCardComponent colors={customization.marketCardColors} />
//                 </div>
//               )}
//             </div>

//             {/* Button Configuration Preview */}
//             <div className="space-y-3">
//               <h4 className="text-sm font-medium text-gray-700">Button Configuration</h4>
//               <div className={`${
//                 customization.buttonConfig.layout === 'horizontal' ? 'flex gap-2' :
//                 customization.buttonConfig.layout === 'vertical' ? 'flex flex-col gap-2' :
//                 customization.buttonConfig.layout === 'grid' ? 'grid grid-cols-2 gap-2' :
//                 'flex flex-col gap-2'
//               }`}>
//                 {Array.from({ length: customization.buttonConfig.count }, (_, i) => (
//                   <button
//                     key={i}
//                     className={`px-3 py-2 rounded-md text-xs font-medium transition-colors ${
//                       customization.buttonConfig.theme === 'solid' ? `text-white` :
//                       customization.buttonConfig.theme === 'gradient' ? `text-white bg-gradient-to-r` :
//                       customization.buttonConfig.theme === 'outline' ? `border-2` :
//                       'bg-transparent hover:bg-gray-100'
//                     }`}
//                     style={{
//                       backgroundColor: customization.buttonConfig.theme === 'solid' ? customization.buttonConfig.colors.primary :
//                                      customization.buttonConfig.theme === 'gradient' ? undefined :
//                                      customization.buttonConfig.theme === 'outline' ? 'transparent' : 'transparent',
//                       backgroundImage: customization.buttonConfig.theme === 'gradient' ? 
//                         `linear-gradient(to right, ${customization.buttonConfig.colors.primary}, ${customization.buttonConfig.colors.secondary})` : undefined,
//                       borderColor: customization.buttonConfig.theme === 'outline' ? customization.buttonConfig.colors.primary : undefined,
//                       color: customization.buttonConfig.theme === 'outline' ? customization.buttonConfig.colors.primary : customization.buttonConfig.colors.text
//                     }}
//                   >
//                     Button {i + 1}
//                   </button>
//                 ))}
//               </div>
//             </div>
//           </div>

//           {/* Footer Navigation Preview */}
//           <div className="mt-auto">
//             {FooterNavComponent && (
//               <FooterNavComponent colors={customization.footerNavColors} />
//             )}
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default PreviewPanel;




import React from 'react';
import { Smartphone, Tablet, Monitor } from 'lucide-react';
import HambergerIcon from 'assets/images/svg/Hamberger.svg';
import KalyanMatkaBlue from 'assets/images/svg/KalyanMatkaBlue.svg';
import WalletIcon from 'assets/images/svg/wallet.svg';
import Frame1 from 'assets/images/svg/Frame1.svg';
import WhatsappIcon from 'assets/images/svg/whatsapp.svg';
import StarlineIcon from 'assets/images/svg/Starline.svg';
import GamesIcon from 'assets/images/svg/Games.svg';
import JackpotIcon from 'assets/images/svg/jackpot.svg';
import LiveUpdatesIcon from 'assets/images/svg/live updates.svg';

interface CustomizationState {
  marketCardLayout: number;
  marketCardColors: {
    background: string;
    text: string;
    button: string;
    buttonText: string;
    status: string;
    border: string;
  };
  footerNavLayout: number;
  footerNavColors: {
    background: string;
    text: string;
    activeBackground: string;
    activeText: string;
    icon: string;
  };
  buttonConfig: {
    count: number;
    theme: string;
    layout: string;
    colors: {
      primary: string;
      secondary: string;
      text: string;
    };
  };
  devicePreview: 'mobile' | 'tablet' | 'desktop';
}

interface PreviewPanelProps {
  customization: CustomizationState;
  marketCardLayouts: any[];
  footerNavLayouts: any[];
}

const PreviewPanel: React.FC<PreviewPanelProps> = ({ 
  customization, 
  marketCardLayouts, 
  footerNavLayouts 
}) => {
  const getDeviceClass = () => {
    switch (customization.devicePreview) {
      case 'mobile':
        return 'w-80 h-[600px]';
      case 'tablet':
        return 'w-96 h-[800px]';
      case 'desktop':
        return 'w-full h-[600px]';
      default:
        return 'w-80 h-[600px]';
    }
  };

  const getDeviceIcon = () => {
    switch (customization.devicePreview) {
      case 'mobile':
        return <Smartphone className="w-4 h-4" />;
      case 'tablet':
        return <Tablet className="w-4 h-4" />;
      case 'desktop':
        return <Monitor className="w-4 h-4" />;
      default:
        return <Smartphone className="w-4 h-4" />;
    }
  };

  const MarketCardComponent = marketCardLayouts.find(
    layout => layout.id === customization.marketCardLayout
  )?.component;

  const FooterNavComponent = footerNavLayouts.find(
    layout => layout.id === customization.footerNavLayout
  )?.component;

  return (
    <div className="bg-gray-50 rounded-lg p-4">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-lg font-semibold text-gray-900">Live Preview</h3>
        <div className="flex items-center gap-2 text-sm text-gray-600">
          {getDeviceIcon()}
          <span className="capitalize">{customization.devicePreview}</span>
        </div>
      </div>

      {/* Device Frame */}
      <div className="flex justify-center">
        <div className={`${getDeviceClass()} bg-white rounded-lg shadow-lg border border-gray-200 overflow-hidden flex flex-col`}>
          {/* App Header */}
          <div className="bg-blue-600 text-white px-4 py-3 flex items-center justify-between">
            <div className="flex items-center gap-3">
              <img src={HambergerIcon} alt="menu" className="w-5 h-5" />
              <img src={KalyanMatkaBlue} alt="Kalyan Matka" className="h-5" />
            </div>
            <img src={WalletIcon} alt="wallet" className="w-5 h-5" />
          </div>

          {/* App Content */}
          <div className="p-4 space-y-4 flex-1 overflow-y-auto">
            {/* Promotional Banner */}
            <div className="rounded-lg overflow-hidden">
              <img src={Frame1} alt="Promo" className="w-full h-auto" />
            </div>

            {/* Action Buttons (reflect current config: count + theme + colors); responsive/wrapping */}
            <div className="flex flex-wrap gap-2">
              {(['STARLINE','GAMES','JACKPOT','LIVE UPDATES'] as const)
                .slice(0, customization.buttonConfig.count)
                .map((label, idx) => {
                  const theme = customization.buttonConfig.theme;
                  const iconMap: Record<string, string> = {
                    'STARLINE': StarlineIcon,
                    'GAMES': GamesIcon,
                    'JACKPOT': JackpotIcon,
                    'LIVE UPDATES': LiveUpdatesIcon,
                  };
                  const baseClasses =
                    theme === 'solid' ? 'text-white' :
                    theme === 'gradient' ? 'text-white bg-gradient-to-r' :
                    theme === 'outline' ? 'border-2' : 'bg-transparent hover:bg-gray-100';
                  const style: React.CSSProperties = {
                    flex: '1 1 120px',
                    backgroundColor: theme === 'solid' ? (idx === 0 ? customization.buttonConfig.colors.primary : customization.buttonConfig.colors.secondary) :
                                      theme === 'gradient' ? undefined :
                                      theme === 'outline' ? 'transparent' : 'transparent',
                    backgroundImage: theme === 'gradient' ? `linear-gradient(to right, ${customization.buttonConfig.colors.primary}, ${customization.buttonConfig.colors.secondary})` : undefined,
                    borderColor: theme === 'outline' ? customization.buttonConfig.colors.primary : undefined,
                    color: theme === 'outline' ? customization.buttonConfig.colors.primary : customization.buttonConfig.colors.text,
                  };
                  return (
                    <button
                      key={label}
                      className={`py-2 px-3 rounded-md text-xs font-medium transition-colors flex items-center justify-center gap-2 ${baseClasses}`}
                      style={style}
                    >
                      <img src={iconMap[label]} alt={label} className="w-3 h-3" />
                      {label}
                    </button>
                  );
                 })}
            </div>

            {/* Contact Info */}
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-1 text-xs text-gray-700 whitespace-nowrap">
                <img src={WhatsappIcon} alt="whatsapp" className="w-[14px] h-[14px]" />
                <span>+91 1234 5678 90</span>
              </div>
              <div className="flex items-center gap-1 text-xs text-gray-700 whitespace-nowrap">
                <img src={WhatsappIcon} alt="whatsapp" className="w-[14px] h-[14px]" />
                <span>+44 1234 5678 90</span>
              </div>
            </div>

            {/* Market Cards Preview */}
            <div className="space-y-4">
              <h4 className="text-sm font-medium text-gray-700">Market Cards</h4>
              {MarketCardComponent && (
                <div className="space-y-4">
                  <MarketCardComponent colors={customization.marketCardColors} />
                  <MarketCardComponent colors={customization.marketCardColors} />
                  <MarketCardComponent colors={customization.marketCardColors} />
                  <MarketCardComponent colors={customization.marketCardColors} />
                </div>
              )}
            </div>

            {/* Button Configuration Preview */}
            <div className="space-y-3">
              <h4 className="text-sm font-medium text-gray-700">Button Configuration</h4>
              <div className={`${
                customization.buttonConfig.layout === 'horizontal' ? 'flex gap-2' :
                customization.buttonConfig.layout === 'vertical' ? 'flex flex-col gap-2' :
                customization.buttonConfig.layout === 'grid' ? 'grid grid-cols-2 gap-2' :
                'flex flex-col gap-2'
              }`}>
                {Array.from({ length: customization.buttonConfig.count }, (_, i) => (
                  <button
                    key={i}
                    className={`px-3 py-2 rounded-md text-xs font-medium transition-colors ${
                      customization.buttonConfig.theme === 'solid' ? `text-white` :
                      customization.buttonConfig.theme === 'gradient' ? `text-white bg-gradient-to-r` :
                      customization.buttonConfig.theme === 'outline' ? `border-2` :
                      'bg-transparent hover:bg-gray-100'
                    }`}
                    style={{
                      backgroundColor: customization.buttonConfig.theme === 'solid' ? customization.buttonConfig.colors.primary :
                                     customization.buttonConfig.theme === 'gradient' ? undefined :
                                     customization.buttonConfig.theme === 'outline' ? 'transparent' : 'transparent',
                      backgroundImage: customization.buttonConfig.theme === 'gradient' ? 
                        `linear-gradient(to right, ${customization.buttonConfig.colors.primary}, ${customization.buttonConfig.colors.secondary})` : undefined,
                      borderColor: customization.buttonConfig.theme === 'outline' ? customization.buttonConfig.colors.primary : undefined,
                      color: customization.buttonConfig.theme === 'outline' ? customization.buttonConfig.colors.primary : customization.buttonConfig.colors.text
                    }}
                  >
                    Button {i + 1}
                  </button>
                ))}
              </div>

              {/* Segmented Rounded Control Preview (mirrors button config colors) */}
              <div className="w-full flex justify-center">
                <div
                  className="flex items-stretch w-[320px] max-w-full rounded-full overflow-hidden"
                  style={{ borderWidth: 2, borderColor: customization.buttonConfig.colors.primary }}
                >
                  <button className="flex-1 flex items-center justify-center gap-2 py-1 text-xs font-medium bg-white"
                          style={{ color: customization.buttonConfig.colors.primary }}>
                    <span>Starline</span>
                    <span className="inline-block w-0 h-0 border-t-4 border-b-4 border-l-6 border-t-transparent border-b-transparent"
                          style={{ borderLeftColor: customization.buttonConfig.colors.primary }} />
                  </button>
                  <div className="w-px" style={{ backgroundColor: customization.buttonConfig.colors.primary }} />
                  <button className="flex-1 flex items-center justify-center gap-2 py-1 text-xs font-medium bg-white"
                          style={{ color: customization.buttonConfig.colors.primary }}>
                    <span>Games</span>
                    <span style={{ color: customization.buttonConfig.colors.primary }}>🎲</span>
                  </button>
                  <div className="w-px" style={{ backgroundColor: customization.buttonConfig.colors.primary }} />
                  <button className="flex-1 flex items-center justify-center gap-2 py-1 text-xs font-medium bg-white"
                          style={{ color: customization.buttonConfig.colors.primary }}>
                    <span>Jackpot</span>
                    <span style={{ color: customization.buttonConfig.colors.primary }}>🎯</span>
                  </button>
                </div>
              </div>
            </div>
          </div>

          {/* Footer Navigation Preview */}
          <div className="mt-auto">
            {FooterNavComponent && (
              <FooterNavComponent colors={customization.footerNavColors} />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PreviewPanel;